import React from "react";
import Banner from "../../components/banner/Banner";
import "./EcoContributor.css";
import CategoryProducts from "../../components/CategoryProducts/CategoryProducts";
import EcoContribtorBenefits from "./EcoContribtorBenefits";
import Title from "../../components/titles/Title";
import CTA from "../../components/CTA/CTA";

// EcoContributor Component
const EcoContributor = () => {
  return (
    <>
      {/* Banner Section */}
      <Banner
        className="eco-contributor-bg"
        bannerTitle={[
          "Adopt an Eco-Bee (Intelligent Hive) to support  ",
          <br className="d-lg-block d-none"></br>,
          "  sustainablilty and biodiversity",
        ]}
      />

      {/* Category Products Section - Adoptable Eco-Bee */}
      <CategoryProducts
        btn1text="Adopt Now"
        btn2text="Model Details"
        categoryId={["AGR16-1000"]}
        title="Adoptable Eco-Bee"
        description="Services not found"
        price="false"
      />

      {/* Benefits Section */}
      <div className="section-container benefit-container">
        <div className="container">
          {/* Title for Benefits */}
          <Title classname="text-center mb-5" heading="Benefits" />
          {/* List of Eco-Contributor Benefits */}
          <EcoContribtorBenefits />
        </div>
      </div>

      {/* Call To Action Section */}
      <CTA
        title="Want to contribute towards sustainability and biodiversity"
        href="https://siapischain-abn.gbrapp.com/auth/undefined/signup"
        buttonText="Start Now"
      />
    </>
  );
};


export default EcoContributor;
